import api from "./api";
import helpers from "./helpers";

const approxPrefix = {
  de: "rund",
  en: "roughly",
};

const placeOfHomePrefix = {
  de: "Wohnort für",
  en: "Place of home for",
};

function getPortraitUrl(figure) {
  const images = figure.images;
  const markedAsPortrait = images.find((image) => image.portrait);
  const portrait = markedAsPortrait || images[0];

  if (!portrait || !portrait.file) return "/img/profile.jpg";

  return api.getAssetUrl(portrait.file.url, { preset: "postcard" });
}

function calculatePlaceOfHomePeriods(stops) {
  return stops.forEach((stop, index) => {
    const type = stop.stop_type.value;

    // we only need to calculate the period for place_of_home stops
    if (type !== "place_of_home") return;

    let startEarlist;
    let startLatest;
    let endEarliest;
    let endLatest;

    const previousStop = stops[index - 1];
    const previousType = previousStop ? previousStop.stop_type.value : null;
    const nextStop = stops[index + 1];
    const nextType = nextStop ? nextStop.stop_type.value : null;

    if (previousType === "trip" || previousType === "stop") {
      startEarlist = previousStop.end_earliest;
      startLatest = previousStop.end_latest;

      if (nextType === "trip" || nextType === "stop") {
        endEarliest = nextStop.start_earliest;
        endLatest = nextStop.start_latest;
      } else {
        endEarliest = stop.end_earliest;
        endLatest = stop.end_latest;
      }
    } else {
      const nextStop = stops[index + 1];

      startEarlist = stop.start_earliest;
      startLatest = stop.start_latest;

      if (nextStop) {
        endEarliest = nextStop.start_earliest;
        endLatest = nextStop.start_latest;
      } else {
        endEarliest = stop.end_earliest;
        endLatest = stop.end_latest;
      }
    }

    const durationObject = helpers.getDurationObject(startEarlist, endLatest);
    const durationInDays = durationObject.asDays();
    const durationInMonths = durationObject.asMonths();

    stop.calculatedPeriod = {
      start_earliest: startEarlist,
      start_latest: startLatest,
      end_earliest: endEarliest,
      end_latest: endLatest,
      duration: {
        inDays: durationInDays,
        inMonths: durationInMonths,
      },
    };
  });
}

function getDuration(stop, locale) {
  const startEarliest = stop.start_earliest;
  const startLatest = stop.start_latest;
  const endEarliest = stop.end_earliest;
  const endLatest = stop.end_latest;
  const type = stop.stop_type.value;

  let durationStart;
  let durationEnd;
  let isExact = false;

  if (startEarliest === startLatest && endEarliest === endLatest) {
    durationStart = startEarliest;
    durationEnd = endEarliest;
    isExact = true;
  } else if (
    startEarliest !== startLatest &&
    endEarliest !== endLatest &&
    startEarliest === endEarliest &&
    startLatest === endLatest
  ) {
    durationStart = startEarliest;
    durationEnd = endLatest;
  } else {
    durationStart = helpers.getDateMidpoint(startEarliest, startLatest);
    durationEnd = helpers.getDateMidpoint(endEarliest, endLatest);
  }

  const durationObject = helpers.getDurationObject(durationStart, durationEnd);
  const durationInDays = durationObject.asDays();
  const durationInMonths = durationObject.asMonths();
  let durationString = durationObject
    .locale(locale)
    .humanize({ d: 26, M: 11 })
    .replace("a ", "1 ")
    .replace("ein ", "1 ");

  if (durationInMonths > 1 && !isExact) {
    durationString = `${approxPrefix[locale]} ${durationString}`;
  }

  if (type === "place_of_home") {
    durationString = `${placeOfHomePrefix[locale]} ${durationString}`;
  }

  // duration smaller than 1 means that the data has an error in the data
  // so we dont show a duration string
  if (durationInDays < 1) {
    durationString = "";
  }

  return {
    inDays: durationInDays,
    inMonths: durationInMonths,
    string: durationString,
    isExact,
  };
}

export default {
  getPortraitUrl,
  getDuration,
  calculatePlaceOfHomePeriods,
};
